import React from 'react';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiIconButton from '@material-ui/core/IconButton';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

const useStyle = makeStyles(() => ({
  expandIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  rotation: {
    transform: 'rotate(180deg)',
  },
  upper: {
    fontSize: '15.38px',
    textTransform: 'uppercase',
  },
  transition: {
    transition: 'transform 0.2s',
  },
  disableHover: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

const IconButton = withStyles({
  root: {
    '&:hover': {
      background: 'inherit',
    },
  },
})(MuiIconButton);

const ArrowIcon = ({
  title,
  actualState,
  editable,
  setEditable,
  isNew,
  expandedState,
}) => {
  const classes = useStyle();
  const handle = (event) => {
    event.stopPropagation();
    if (expandedState) {
      setEditable(!editable);
    }
  };

  const expandMoreIconClassNames = [classes.disableHover, classes.transition];
  if (actualState) {
    expandMoreIconClassNames.push(classes.rotation);
  }

  return (
    <div className={classes.expandIcon}>
      <div className={classes.icon}>
        <IconButton className={classes.margin}>
          <ExpandMoreIcon className={expandMoreIconClassNames.join(' ')} />
        </IconButton>
      </div>
      {!isNew && !editable && (
        <div className={classes.upper} onClick={handle}>
          {<FormattedMessage id={title} />}
        </div>
      )}
    </div>
  );
};

ArrowIcon.propTypes = {
  title: PropTypes.string,
  editable: PropTypes.bool,
  setEditable: PropTypes.func,
  actualState: PropTypes.bool,
  isNew: PropTypes.bool,
  expandedState: PropTypes.bool,
};

export default ArrowIcon;
